import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import UpcomingAppointments from './UpcomingAppointments';
import AppointmentHistory from './AppointmentHistory';
import { useTranslation } from 'react-i18next';

interface ClientAppointmentsViewProps {
  unreadByBooking: Record<string, number>;
  onRefreshUnreadCounts: () => void;
  onUpcomingUnreadCountChange?: (count: number) => void;
  onHistoryUnreadCountChange?: (count: number) => void;
}

const ClientAppointmentsView: React.FC<ClientAppointmentsViewProps> = ({
  unreadByBooking,
  onRefreshUnreadCounts,
  onUpcomingUnreadCountChange,
  onHistoryUnreadCountChange,
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">{t('appointmentsLabel', { defaultValue: 'Appointments' })}</h2>
      <Tabs defaultValue="upcoming" className="w-full">
        <TabsList className="mb-3 sm:mb-4 grid w-full grid-cols-2 h-auto">
          <TabsTrigger value="upcoming" className="text-xs sm:text-sm py-2">
            {t('upcoming', { defaultValue: 'Upcoming' })}
          </TabsTrigger>
          <TabsTrigger value="history" className="text-xs sm:text-sm py-2">
            {t('history', { defaultValue: 'History' })}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="upcoming">
          <UpcomingAppointments
            unreadByBooking={unreadByBooking}
            onUnreadCountChange={onUpcomingUnreadCountChange}
            onRefreshUnreadCounts={onRefreshUnreadCounts}
          />
        </TabsContent>
        <TabsContent value="history">
          <AppointmentHistory
            unreadByBooking={unreadByBooking}
            onUnreadCountChange={onHistoryUnreadCountChange}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ClientAppointmentsView;
